
define('text!templates/layouts/layout-body.html',[],function () { return '<div id="loading" class="hidden"></div>\n<div id="app"></div>\n';});

